import config from 'config/config.json';

export type PortalType = 'patient' | 'staff' | 'tenant';

const configAny = config as any;
// New string-based PORTAL field, with legacy PATIENT boolean fallback
const resolvedPortal: PortalType = configAny.PORTAL ?? (configAny.PATIENT ? 'patient' : 'staff');

export const PORTAL: PortalType = resolvedPortal;
export const isPatientPortal = PORTAL === 'patient';
export const isStaffPortal = PORTAL === 'staff';
export const isTenantPortal = PORTAL === 'tenant';
